import React from 'react';
import { ChannelCallback } from './ChannelCallback';

/** /auth/youtube/callback — the shared sign-in callback (ChannelCallback) for YouTube. */
const YouTubeCallback: React.FC = () => <ChannelCallback platform="youtube" />;

export default YouTubeCallback;
